import { ReactComponent as Analytics } from '../../common/icons/Analytics.svg';
import { ReactComponent as AddSquare } from '../../common/icons/AddSquare.svg';
import { ReactComponent as Calendar } from '../../common/icons/Calendar.svg';
import { ReactComponent as Camera } from '../../common/icons/Camera.svg';
import { ReactComponent as Chat } from '../../common/icons/Chat.svg';
import { ReactComponent as Checkmark } from '../../common/icons/Checkmark.svg';
import { ReactComponent as ChevronDown } from '../../common/icons/Chevron Down.svg';
import { ReactComponent as ChevronLeft } from '../../common/icons/Chevron Left.svg';
import { ReactComponent as ChevronRight } from '../../common/icons/Chevron Right.svg';
import { ReactComponent as ChevronUp } from '../../common/icons/Chevron Up.svg';
import { ReactComponent as Close } from '../../common/icons/Close.svg';
import { ReactComponent as Cog } from '../../common/icons/Cog.svg';
import { ReactComponent as Copy } from '../../common/icons/Copy.svg';
import { ReactComponent as Collapse } from '../../common/icons/Collapse.svg';
import { ReactComponent as Delete } from '../../common/icons/Delete.svg';
import { ReactComponent as EmailUnread } from '../../common/icons/Email Unread.svg';
import { ReactComponent as EndCall } from '../../common/icons/End Call.svg';
import { ReactComponent as ExclamationPoint } from '../../common/icons/ExclamationPoint.svg';
import { ReactComponent as ExclamationPointCircle } from '../../common/icons/ExclamationPointCircle.svg';
import { ReactComponent as Error } from '../../common/icons/Error.svg';
import { ReactComponent as FileTransfer } from '../../common/icons/FileTransfer.svg';
import { ReactComponent as Filter } from '../../common/icons/Filter.svg';
import { ReactComponent as FullScreen } from '../../common/icons/Full Screen.svg';
import { ReactComponent as GalleryView } from '../../common/icons/GalleryView.svg';
import { ReactComponent as Group } from '../../common/icons/Group.svg';
import { ReactComponent as Group2 } from '../../common/icons/Group2.svg';
import { ReactComponent as GroupCall } from '../../common/icons/GroupCall.svg';
import { ReactComponent as Hamburger } from '../../common/icons/Hamburger.svg';
import { ReactComponent as Help } from '../../common/icons/Help.svg';
import { ReactComponent as History } from '../../common/icons/History.svg';
import { ReactComponent as HorizontalDots } from '../../common/icons/Horizontal Dots.svg';
import { ReactComponent as Info } from '../../common/icons/Info.svg';
import { ReactComponent as Interpreter } from '../../common/icons/Interpreter.svg';
import { ReactComponent as LeftArrow } from '../../common/icons/Left Arrow.svg';
import { ReactComponent as Location } from '../../common/icons/Location.svg';
import { ReactComponent as Logout } from '../../common/icons/Logout.svg';
import { ReactComponent as Loader } from '../../common/icons/Loader.svg';
import { ReactComponent as MapIcon } from '../../common/icons/Map.svg';
import { ReactComponent as Marketplace } from '../../common/icons/Marketplace.svg';
import { ReactComponent as MicrophoneOff } from '../../common/icons/Microphone Off.svg';
import { ReactComponent as Microphone } from '../../common/icons/Microphone.svg';
import { ReactComponent as Pause } from '../../common/icons/Pause.svg';
import { ReactComponent as Person } from '../../common/icons/Person.svg';
import { ReactComponent as PictureInPicture } from '../../common/icons/Picture in Picture.svg';
import { ReactComponent as Plus } from '../../common/icons/Plus.svg';
import { ReactComponent as Refresh } from '../../common/icons/Refresh.svg';
import { ReactComponent as Remove } from '../../common/icons/Remove.svg';
import { ReactComponent as RightArrow } from '../../common/icons/Right Arrow.svg';
import { ReactComponent as ScreenShare } from '../../common/icons/Screen Share.svg';
import { ReactComponent as Settings } from '../../common/icons/Settings.svg';
import { ReactComponent as CallSettings } from '../../common/icons/call-settings.svg';
import { ReactComponent as Sorting } from '../../common/icons/Sorting.svg';
import { ReactComponent as ShoppingCart } from '../../common/icons/Shopping Cart.svg';
import { ReactComponent as Teleconsent } from '../../common/icons/Teleconsent.svg';
import { ReactComponent as Telesurvey } from '../../common/icons/Telesurvey.svg';
import { ReactComponent as Transfer } from '../../common/icons/Transfer.svg';
import { ReactComponent as Upgrade } from '../../common/icons/Upgrade.svg';
import { ReactComponent as Upload } from '../../common/icons/Upload.svg';
import { ReactComponent as User } from '../../common/icons/User.svg';
import { ReactComponent as UserCommunity } from '../../common/icons/User Community.svg';
import { ReactComponent as VerticalDots } from '../../common/icons/Vertical Dots.svg';
import { ReactComponent as VideoOff } from '../../common/icons/Video Off.svg';
import { ReactComponent as VideoPlay } from '../../common/icons/Video Play.svg';
import { ReactComponent as Video } from '../../common/icons/Video.svg';
import { ReactComponent as WaitingRoom } from '../../common/icons/Waiting Room.svg';
import { ReactComponent as Wallet } from '../../common/icons/Wallet.svg';
import { ReactComponent as Whiteboard } from '../../common/icons/Whiteboard.svg';
import { ReactComponent as Gauge } from '../../common/icons/Gauge.svg';
import { ReactComponent as Search } from '../../common/icons/Search.svg';
import { ReactComponent as PassHide } from '../../common/icons/PassHide.svg';
import { ReactComponent as PassShow } from '../../common/icons/PassShow.svg';
import { ReactComponent as SearchResult } from '../../common/icons/SearchResult.svg';
import { ReactComponent as Globe } from '../../common/icons/Globe.svg';
import { ReactComponent as Flyer } from '../../common/icons/Flyer.svg';
import { ReactComponent as SocialMedia } from '../../common/icons/SocialMedia.svg';
import { ReactComponent as CalendarSimple } from '../../common/icons/CalendarSimple.svg';
import { ReactComponent as TimeClock } from '../../common/icons/Time Clock.svg';
import { ReactComponent as Cloud } from '../../common/icons/Cloud.svg';
import { ReactComponent as Google } from '../../common/icons/Google.svg';
import { ReactComponent as Windows } from '../../common/icons/Windows.svg';
import { ReactComponent as Yahoo } from '../../common/icons/Yahoo.svg';
import { ReactComponent as CheckmarkFilled } from '../../common/icons/checkmark-filled.svg';
import { ReactComponent as QuestionMark } from '../../common/icons/question-mark.svg';
import { ReactComponent as Exclamation } from '../../common/icons/exclamation.svg';
import { ReactComponent as ClinicGenericPicture } from '../../common/icons/clinic-generic-picture.svg';
import { ReactComponent as Clock } from '../../common/icons/clock.svg';
import { ReactComponent as Idea } from '../../common/icons/idea.svg';
import { ReactComponent as Laptop } from '../../common/icons/laptop.svg';
import { ReactComponent as Pencil } from '../../common/icons/pencil.svg';
import { ReactComponent as Star } from '../../common/icons/star.svg';
import { ReactComponent as Time } from '../../common/icons/time.svg';
import { ReactComponent as TransferPatient } from '../../common/icons/transfer-patient.svg';
import { ReactComponent as CallSettingsCose } from '../../common/icons/call-settings-close.svg';
import { ReactComponent as CallVideoOff } from '../../common/icons/call-video-off.svg';
import { ReactComponent as ExportUsers } from '../../common/icons/export-users.svg';
import { ReactComponent as StepperCheckMark } from '../../common/icons/stepper-check-mark.svg';
import { ReactComponent as Arrow } from '../../common/icons/arrow.svg';
import { ReactComponent as Circle } from '../../common/icons/circle.svg';
import { ReactComponent as DocTextInv } from '../../common/icons/doc-text-inv.svg';
import { ReactComponent as Ok } from '../../common/icons/ok.svg';
import { ReactComponent as Spin5 } from '../../common/icons/spin5.svg';
import { ReactComponent as TakeScreenshot } from '../../common/icons/take-screenshot.svg';
import { ReactComponent as CloseOld } from '../../common/icons/close-old.svg';
import { ReactComponent as MenuKebab } from '../../common/icons/MenuKebab.svg';
import { ReactComponent as Troubleshooting } from '../../common/icons/troubleshooting.svg';
import { ReactComponent as VisualEffects } from '../../common/icons/visual-effects.svg';
import { ReactComponent as Avatar } from '../../common/icons/avatar.svg';
import { ReactComponent as ClosedCaptions } from '../../common/icons/closed-captions.svg';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const IconsSet = {
  analytics: Analytics,
  'add-square': AddSquare,
  arrow: Arrow,
  avatar: Avatar,
  calendar: Calendar,
  camera: Camera,
  chat: Chat,
  circle: Circle,
  checkmark: Checkmark,
  'checkmark-field': CheckmarkFilled,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  'clinic-generic-picture': ClinicGenericPicture,
  'call-settings-close': CallSettingsCose,
  'call-video-off': CallVideoOff,
  'close-old': CloseOld,
  clock: Clock,
  close: Close,
  cog: Cog,
  copy: Copy,
  collapse: Collapse,
  'doc-text-inv': DocTextInv,
  delete: Delete,
  'export-users': ExportUsers,
  'email-unread': EmailUnread,
  'end-call': EndCall,
  error: Error,
  exclamation: Exclamation,
  'exclamation-point': ExclamationPoint,
  'exclamation-point-circle': ExclamationPointCircle,
  'file-transfer': FileTransfer,
  filter: Filter,
  'full-screen': FullScreen,
  'gallery-view': GalleryView,
  group: Group,
  group2: Group2,
  'group-call': GroupCall,
  hamburger: Hamburger,
  'menu-kebab': MenuKebab,
  help: Help,
  history: History,
  'horizontal-dots': HorizontalDots,
  idea: Idea,
  interpreter: Interpreter,
  info: Info,
  laptop: Laptop,
  'left-arrow': LeftArrow,
  location: Location,
  logout: Logout,
  loader: Loader,
  map: MapIcon,
  marketplace: Marketplace,
  'microphone-off': MicrophoneOff,
  microphone: Microphone,
  ok: Ok,
  pause: Pause,
  pencil: Pencil,
  person: Person,
  'picture-in-picture': PictureInPicture,
  plus: Plus,
  refresh: Refresh,
  remove: Remove,
  'right-arrow': RightArrow,
  'screen-share': ScreenShare,
  settings: Settings,
  'call-settings': CallSettings,
  sorting: Sorting,
  'stepper-check-mark': StepperCheckMark,
  'shopping-cart': ShoppingCart,
  search: Search,
  star: Star,
  spin5: Spin5,
  time: Time,
  'take-screenshot': TakeScreenshot,
  teleconsent: Teleconsent,
  telesurvey: Telesurvey,
  transfer: Transfer,
  upgrade: Upgrade,
  upload: Upload,
  user: User,
  'user-community': UserCommunity,
  'vertical-dots': VerticalDots,
  'video-off': VideoOff,
  'video-play': VideoPlay,
  video: Video,
  'waiting-room': WaitingRoom,
  wallet: Wallet,
  whiteboard: Whiteboard,
  gauge: Gauge,
  'password-hide': PassHide,
  'password-show': PassShow,
  'search-result': SearchResult,
  globe: Globe,
  flyer: Flyer,
  'social-media': SocialMedia,
  'calendar-simple': CalendarSimple,
  'time-clock': TimeClock,
  'transfer-patient': TransferPatient,
  cloud: Cloud,
  google: Google,
  windows: Windows,
  yahoo: Yahoo,
  'question-mark': QuestionMark,
  troubleshooting: Troubleshooting,
  'visual-effects': VisualEffects,
  'closed-captions': ClosedCaptions,
};

const IconsList = Object.keys(IconsSet);

export type IconName = keyof typeof IconsSet;

export { IconsSet, IconsList };
